





import { defineComponent } from "@vue/composition-api";
import { Subscription } from "@teacherskaya/api-provider/dist/api/SubscriptionProvider";
import { $t } from "@/lib/helpers/i18nHelper";
import { formatMoney } from "@/lib/helpers/money";
import { formatDate } from "@/lib/helpers/time";
import emitter from "@/lib/helpers/emitter";
import ModalConfirm from "@/components/ModalConfirm.vue";

export default defineComponent({
  name: "ConfirmRecurringAction",
  components: { ModalConfirm },
  props: {
    name: { type: String, default: "recurringAction" },
  },
  data() {
    return {
      confirmRecurring: false,
      confirmState: "",
      confirmRecurringText: "",
      selectedSubscription: null as Subscription | null,
    };
  },
  methods: {
    onRecurringAction(subscription: Subscription, state: string) {
      if (subscription.recurringBillingSchedule) {
        if (state === "cancelRebill") {
          this.confirmRecurringText = $t("cancel_rebill_subscription_confirm_text", {
            price: formatMoney(
              subscription.recurringBillingSchedule.cost.cost,
              subscription.recurringBillingSchedule.cost.currency
            ),
            providerName: subscription.provider.screenName,
            consumerName: subscription.consumer.screenName,
            date: subscription.expirationTime
              ? formatDate(subscription.recurringBillingSchedule.schedule.nextBillingTime)
              : "",
          });
        } else if (state === "removeAccess") {
          this.confirmRecurringText = $t("remove_access_subscription_confirm_text", {
            price: formatMoney(
              subscription.recurringBillingSchedule.cost.cost,
              subscription.recurringBillingSchedule.cost.currency
            ),
            providerName: subscription.provider.screenName,
            consumerName: subscription.consumer.screenName,
          });
        }
      } else {
        if (state === "removeAccess") {
          this.confirmRecurringText = $t("remove_access_manual_subscription_confirm_text", {
            providerName: subscription.provider.screenName,
            consumerName: subscription.consumer.screenName,
          });
        }
      }
      this.confirmState = state;
      this.confirmRecurring = true;
      this.selectedSubscription = subscription;
    },
    onConfirmRecurringAction() {
      this.$emit(this.confirmState, this.selectedSubscription);
      this.onConfirmRecurringCancel();
    },
    onConfirmRecurringCancel() {
      this.confirmRecurring = false;
      this.confirmState = "";
      this.confirmRecurringText = "";
      this.selectedSubscription = null;
    },
    showConfirm({ name, subscription, eventName }: { name: string; subscription: Subscription; eventName: string }) {
      if (name === this.name) this.onRecurringAction(subscription, eventName);
    },
  },
  created() {
    emitter.on<any>("showConfirmRecurringAction", this.showConfirm);
  },
  beforeDestroy() {
    emitter.off<any>("showConfirmRecurringAction", this.showConfirm);
  },
});
